import { render } from "./CardListComponent.vue?vue&type=template&id=b2432426&ts=true"
import script from "./CardListComponent.vue?vue&type=script&lang=ts"
export * from "./CardListComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__